export function makeShortName(teamName: string): string {
    return teamName
        ? teamName.replace(/\s/g, "").substring(0, 3).toUpperCase()
        : "";
}
